<template>
  <div>
    <v-app-bar
      app
      v-if="!$root.fullScreenView"
      color="white"
      class="elevation-3 pl-2 pr-4"
    >
      <div class="logo">
        <a href="https://www.accelefreight.com" class="navbar-brand logo">
          <img src="@/assets/logo.svg" alt="AcceleFreight" width="100px" />
        </a>
      </div>
      <v-divider vertical inset></v-divider>

      <v-toolbar-items>
        <!-- Dashboard -->
        <v-btn
          class="app-bar-btn font-weight-light body-2"
          text
          :to="{ name: 'userdashboard' }"
          >Dashboard</v-btn
        >

        <!-- Quotations -->
        <v-btn
          :disabled="!$root.is_allow_access"
          class="app-bar-btn font-weight-light body-2"
          text
          :to="{ name: 'quotations' }"
          >Quotations</v-btn
        >

        <!-- Bookings -->
        <v-btn
          :disabled="!$root.is_allow_access"
          class="app-bar-btn font-weight-light body-2"
          text
          :to="{ name: 'bookings' }"
          >Bookings</v-btn
        >

        <!-- Shipments & Calendar view -->
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              :disabled="!$root.is_allow_access"
              class="app-bar-btn font-weight-light body-2"
              text
              v-on="on"
            >
              Shipments
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <!-- Drop down Menu -->
          <v-list v-if="$root.is_allow_access">
            <v-list-item :to="{ name: 'shipments' }" class="app-bar-sub-menu">
              <v-list-item-icon>
                <v-icon>mdi-ferry</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >All Shipments</v-list-item-title
              >
            </v-list-item>

            <v-list-item
              :to="{ name: 'shipmentscalendarview' }"
              class="app-bar-sub-menu"
            >
              <v-list-item-icon>
                <v-icon>mdi-calendar-range</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Calendar View</v-list-item-title
              >
            </v-list-item>

            <v-list-item
              :to="{ name: 'portshipmenttasks' }"
              class="app-bar-sub-menu"
              v-if="$root.is_admin"
            >
              <v-list-item-icon>
                <v-icon>mdi-calendar-check</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Port Shipments</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- User Invoice -->
        <!-- Removed due to incompatibility with Xero -->
        <!-- <v-btn
          :disabled="!$root.is_allow_access"
          class="app-bar-btn font-weight-light body-2"
          text
          :to="{ name: 'invoices' }"
          >Invoices</v-btn
        > -->

        <!-- User Account -->
        <v-btn
          v-if="!$root.is_admin"
          class="app-bar-btn font-weight-light body-2"
          text
          :to="{ name: 'useraccount' }"
          >User Account</v-btn
        >

        <!-- Admin -->
        <v-menu open-on-hover bottom offset-y v-if="$root.is_admin">
          <template v-slot:activator="{ on }">
            <v-btn class="app-bar-btn font-weight-light body-2" text v-on="on">
              Admin
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item :to="{ name: 'useraccount' }" class="app-bar-sub-menu">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Profile</v-list-item-title
              >
            </v-list-item>

            <v-list-item
              :to="{ name: 'admindashboard' }"
              class="app-bar-sub-menu"
            >
              <v-list-item-icon>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Admin Dashboard</v-list-item-title
              >
            </v-list-item>

            <v-list-item
              :to="{ name: 'admingeography' }"
              class="app-bar-sub-menu"
            >
              <v-list-item-icon>
                <v-icon>mdi-earth</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Geography</v-list-item-title
              >
            </v-list-item>

            <v-list-item
              :to="{ name: 'adminpricingtable' }"
              class="app-bar-sub-menu"
            >
              <v-list-item-icon>
                <v-icon>mdi-cash-usd</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-light body-2"
                >Pricing Tables</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Admin Board -->
        <template v-if="$root.is_admin">
          <v-btn
            class="app-bar-btn font-weight-light body-2"
            text
            :to="{ name: 'adminboard' }"
          >
            <v-badge
              class="font-weight-bold"
              :content="$root.admin_board_unread_count"
              :value="$root.admin_board_unread_count"
              color="error"
              overlap
              bordered
              offset-x="-1"
            >
              <span>Admin Board</span>
            </v-badge>
          </v-btn>
        </template>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-switch
        class="pt-3 mr-1 font-weight-bold"
        v-if="$root.email == 'isaac@accelefreight.com'"
        v-model="admin"
        :label="admin ? 'Admin' : 'Customer'"
      ></v-switch>

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="27" color="error" @click="logout"
            >mdi-power</v-icon
          >
        </template>
        Log out
      </v-tooltip>

      <!-- Button for Authenticating with Xero -->
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-icon
            v-if="$root.is_super_admin"
            v-on="on"
            size="27"
            color="primary"
            @click="authenticate_xero_connection()"
            >$xero</v-icon
          >
        </template>
        Connect to Xero
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" size="25" color="primary" @click="toProfile"
            >mdi-account-circle</v-icon
          >
        </template>
        {{ $root.username }}
      </v-tooltip>

      <template v-if="$root.is_admin">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-badge
              class="font-weight-bold"
              :content="$root.unread_count"
              :value="$root.unread_count"
              color="error"
              overlap
              bordered
              offset-x="12"
            >
              <v-btn
                class="pb-1"
                v-on="on"
                icon
                small
                @click="notificationSideBar = !notificationSideBar"
              >
                <v-icon size="26" color="primary">mdi-bell</v-icon>
              </v-btn>
            </v-badge>
          </template>
          Notifications
        </v-tooltip>
      </template>
    </v-app-bar>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-dialog
      v-model="notificationSideBar"
      fullscreen
      transition="slide-x-reverse-transition"
    >
      <v-card tile flat color="white">
        <v-toolbar dense flat color="primary" dark height="40">
          <!-- <v-icon class="mr-4" size="20">mdi-bell</v-icon> -->
          <v-toolbar-title class="font-weight-bold subtitle-2"
            >Notifications</v-toolbar-title
          >
          <v-spacer></v-spacer>

          <v-btn
            x-small
            class="caption pr-0 pt-1"
            color="white"
            text
            @click="$root.mark_all_as_read()"
            >Mark All as Read</v-btn
          >

          <v-btn icon @click="notificationSideBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider class="my-1"></v-divider>

        <v-card-text class="px-0 pt-0 pb-0">
          <v-row no-gutters>
            <v-col>
              <template v-for="(item, id) in $root.notifications">
                <v-card :key="id" flat tile color="white">
                  <template v-if="new_notifications(item, id)">
                    <v-card-title
                      class="caption white--text py-0 primary lighten-1"
                      >NEW</v-card-title
                    >
                    <v-divider class="my-1"></v-divider>
                  </template>

                  <template v-if="earlier_notifications(item, id)">
                    <v-card-title
                      class="caption white--text py-0 primary lighten-1"
                      >EARLIER</v-card-title
                    >
                    <v-divider class="my-1"></v-divider>
                  </template>

                  <template v-if="yesterday_notifications(item, id)">
                    <v-card-title
                      class="caption white--text py-0 primary lighten-1"
                      >YESTERDAY</v-card-title
                    >
                    <v-divider class="my-1"></v-divider>
                  </template>

                  <template v-if="later_notifications(item, id)">
                    <v-card-title
                      class="caption white--text py-0 primary lighten-1"
                      >LATER</v-card-title
                    >
                    <v-divider class="my-1"></v-divider>
                  </template>

                  <v-row no-gutters>
                    <v-col>
                      <v-card
                        flat
                        tile
                        class="py-1"
                        :color="!item.data.read ? '#EDF2FA' : 'white'"
                      >
                        <v-row no-gutters>
                          <v-col class="d-flex align-center justify-center">
                            <div
                              :style="`background-color: ${
                                get_entity_type(item).color
                              }`"
                              class="rounded-icon"
                            >
                              <v-icon
                                size="21"
                                class="d-flex pt-2"
                                color="white"
                                >{{ get_entity_type(item).icon }}</v-icon
                              >
                            </div>
                          </v-col>
                          <v-col cols="10" class="pr-1">
                            <v-row no-gutters>
                              <v-col cols="10">
                                <span
                                  class="font-weight-light black--text caption"
                                  >{{ item.data.message }}</span
                                >
                              </v-col>

                              <v-col
                                class="d-flex justify-content-end"
                                v-if="!item.data.read"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      text
                                      icon
                                      color="grey"
                                      @click="markAsRead(item)"
                                    >
                                      <v-icon size="15">mdi-eye</v-icon>
                                    </v-btn>
                                  </template>
                                  Mark as Read
                                </v-tooltip>
                              </v-col>
                            </v-row>

                            <v-row no-gutters>
                              <v-col>
                                <span
                                  class="
                                    grey--text
                                    text--darken-2
                                    overline
                                    text-lowercase
                                  "
                                >
                                  {{ MOMENT(item.data.createdOnStr).fromNow() }}
                                </span>
                              </v-col>

                              <v-col class="d-flex justify-content-end">
                                <span
                                  class="
                                    grey--text
                                    text--darken-2
                                    overline
                                    text-lowercase
                                    pt-1
                                  "
                                  >by: {{ item.data.sender.first_name }}</span
                                >
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider class="my-1"></v-divider>
                  </v-row>
                </v-card>
              </template>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pt-0">
          <v-row justify="center">
            <v-btn
              small
              text
              class="font-weight-bold body-2 primary--text"
              @click="seeMore"
              >See More</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import constant from "../const"
import moment from "moment"
export default {
  data() {
    return {
      MOMENT: moment,
      notificationSideBar: false,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,
      alert: false,
      alertType: "success",
      alertMessage: "",
      dialogNewQuotation: false,
      admin: true,
    }
  },
  created() {
    // init user
    this.$root.init()

    // if afu admin ONLY
    if (this.$root.is_admin) {
      // if route is not print-quotation-overview
      if (this.$route.name != "print-quotation-overview") {
        // fetch the first 20 records
        this.$root.fetch_notifications()
      }
    }
  },

  watch: {
    admin(val) {
      if (val) {
        this.$store.state.user.role = constant.ACCOUNT_ADMIN
      } else {
        this.$store.state.user.role = constant.ACCOUNT_CUSTOMER
      }
    },
  },
  methods: {
    /**
     * Profile page
     */
    toProfile() {
      this.$router.push({ name: "useraccount" })
    },

    /**
     * Logout
     */
    logout() {
      // block the ui
      this.$root.blockUImsg = "logging out..."
      this.$root.blockUIshow = true

      this.$root
        .logout()
        .then(() => {})
        .catch((err) => {})
        .finally(() => {
          this.$root.blockUIshow = false
        })
    },

    /**
     * Initiate connection to Xero
     */
    authenticate_xero_connection() {
      this.$root.blockUImsg = "Authenticating xero"
      this.$root.blockUIshow = true

      if (
        (!this.$root.has_xero_access_token &&
          !this.$root.has_xero_refresh_token) ||
        (this.$root.has_xero_access_token && !this.$root.has_xero_refresh_token)
      ) {
        // exchange auth code to get access token & refresh token
        // window.open(constant.XERO_AUTH_URL)
        window.location.href = constant.XERO_AUTH_URL
      } else if (
        !this.$root.has_xero_access_token &&
        this.$root.has_xero_refresh_token
      ) {
        // use refresh token to get a new access token & refresh token
        this.$root.xero_refresh_access_token()

        this.$root.blockUIshow = false

        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = "Xero is connected"

        console.log("Refreshed Access Token")
      } else if (
        this.$root.has_xero_access_token &&
        this.$root.has_xero_refresh_token
      ) {
        this.$root.blockUIshow = false
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = "Xero is connected"
      } else {
        console.log("Access Token & Refresh Token cookies has a problem")
        console.log(
          "has access token: ",
          this.$root.has_xero_access_token,
          " access token: ",
          this.$root.xero_access_token
        )
        console.log(
          "has refresh token: ",
          this.$root.has_xero_refresh_token,
          " refresh token: ",
          this.$root.xero_refresh_token
        )
      }
    },

    /**
     * Entity Type
     */
    get_entity_type(item) {
      let icon = "mdi-bell"
      let color = "#212121" // grey darken-4

      switch (item.data.entity) {
        case "invoice":
          icon = "fa-file-invoice-dollar"
          color = "#4CAF50" // green
          break

        case "quotation":
          icon = "fa-file-invoice"
          color = "#607D8B" // blue-grey darken-4
          break

        case "booking":
          icon = "mdi-book"
          color = "#FF6F00" // amber darken-4
          break

        case "useraccount":
          icon = "mdi-account"
          color = "#1976D2" // primary
          break

        case "company":
          icon = "mdi-domain"
          color = "#64B5F6" // secondary
          break

        case "task":
          icon = "mdi-calendar-check"
          color = "#1B5E20" // green darken-4
          break

        case "email":
          icon = "mdi-email"
          color = "#2196F3" // blue
          break

        case "shipment":
          if (item.data.entity_type == "AIR") {
            icon = "mdi-airplane-takeoff"
            color = "#0091EA" // light-blue accent-4
          } else {
            icon = "mdi-ferry"
            color = "#01579B" // light-blue darken-4
          }
          break
        default:
          break
      }

      return { icon: icon, color: color }
    },

    /**
     * Find new notifications
     */
    new_notifications(item, index) {
      var spatt = /seconds/g
      var mpatt = /minute/g
      var ahpatt = /an hour/g
      var hpatt = /^\d\shour/g

      const timeago = moment(moment(item.data.createdOnStr)).fromNow(true)

      var sresult = timeago.match(spatt)
      var mresult = timeago.match(mpatt)
      var ahresult = timeago.match(ahpatt)
      var hresult = timeago.match(hpatt)
      if (
        index == 0 &&
        (sresult != null ||
          mresult != null ||
          ahresult != null ||
          hresult != null)
      ) {
        return true
      } else {
        return false
      }
    },

    /**
     * Find earlier notifications
     */
    earlier_notifications(item, index) {
      var patt = /^\d\d\shours/g

      const earlier = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var result = timeago.match(patt)
        if (result != null) {
          return true
        } else {
          return false
        }
      }

      // if prev is not earlier
      const prev = index - 1
      if (index > 0 && !earlier(this.$root.notifications[prev])) {
        return earlier(item)
      } else if (index == 0) {
        return earlier(item)
      } else {
        return false
      }
    },

    /**
     * Find yesterday notifications
     */
    yesterday_notifications(item, index) {
      var patt = /^a day/g
      const yesterday = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var result = timeago.match(patt)
        if (result != null) {
          return true
        } else {
          return false
        }
      }

      // if prev is not yesterday
      const prev = index - 1
      if (index > 0 && !yesterday(this.$root.notifications[prev])) {
        return yesterday(item)
      } else if (index == 0) {
        return yesterday(item)
      } else {
        return false
      }
    },

    /**
     * Find later notifications
     */
    later_notifications(item, index) {
      var days_patt = /days/g
      var month_patt = /month/g
      var year_patt = /year/g

      const later = (obj) => {
        const timeago = moment(moment(obj.data.createdOnStr)).fromNow(true)

        var days_result = timeago.match(days_patt)
        var month_result = timeago.match(month_patt)
        var year_result = timeago.match(year_patt)
        if (
          days_result != null ||
          month_result != null ||
          year_result != null
        ) {
          return true
        } else {
          return false
        }
      }

      // if prev is not later
      const prev = index - 1
      if (index > 0 && !later(this.$root.notifications[prev])) {
        return later(item)
      } else if (index == 0) {
        return later(item)
      } else {
        return false
      }
    },

    /**
     * Mark notification message as read
     */
    markAsRead(item) {
      item.data.read = true
      this.$root.user_seen_notification(item.nid)
    },

    /**
     * Fetch more notifications messages
     */
    seeMore() {
      // increase the limit by 20
      this.$root.notifications_limit += 20
      this.$root.fetch_notifications(this.$root.notifications_limit)
    },

    /** open port shipments */
    openPortShipments() {
      let routeData = this.$router.resolve({
        name: "portshipmenttasks",
        params: { port_un_code: "MYPKG_N" },
      })
      window.open(routeData.href + "?port_un_code=MYPKG_N", "_blank")
    },
  },

  computed: {
    // noMore() {
    //   if (this.$root.notifications.length >= this.$root.total_notifications) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }
  },
}
</script>

<style scoped>
.v-btn.app-bar-btn {
  text-decoration: none;
}
.app-bar-btn.v-btn--active {
  color: #1976d2;
  font-weight: bold !important;
  text-decoration: none;
}

.app-bar-btn:hover {
  background-color: #bcd0e4;
}

.app-bar-sub-menu {
  cursor: pointer;
  text-decoration: none;
}

.app-bar-sub-menu.v-list-item--active {
  color: #1976d2;
  font-weight: bold !important;
  text-decoration: none;
}

.app-bar-sub-menu:hover {
  background-color: #bcd0e4;
}

.rounded-icon {
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

::v-deep .v-dialog--fullscreen {
  border-radius: 0;
  margin-left: 73%;
  /* margin-bottom: 10%; */
  height: 90%;
  width: 27%;
  position: fixed;
  overflow-y: auto;
  top: 0%;
  left: 0%;
}
</style>
